import '../../stylesheets/App.css';
//import '../../stylesheets/PopupRegister.css';
import React, {useState} from 'react';
import { useNavigate } from "react-router-dom";
import DetallePago from '../popups/DetallePago';
import DetalleRefPago from '../popups/DetalleRefPago';
import Swal from 'sweetalert2';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getHeaders } from '../../helpers/apiCallConfiguration';

library.add(faTrash);

function DetallePagosPorVenta(props) {

    let [cargarNuevoPago, setCargarNuevoPago] = useState(false);

    const cancelarPago = async (item) => {
        let resultSwal = await Swal.fire({
            title: '¿Eliminar este pago?',
            text: 'Esta acción recalculará el estado de las cuotas.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
        });
        if (resultSwal.isConfirmed) {
            const endpoint = item.idPago ? '/pagos/deactivate' : '/refpagos/deactivate';
            const body = item.idPago ? { idPago: item.idPago } : { idRefPago: item.idRefPago };
            let result = await fetch(
                process.env.REACT_APP_API_BASE_URL + endpoint,
                { method: 'PUT', headers: getHeaders(), body: JSON.stringify(body) }
            );
            result = await result.json();
            if (result.status == 200) {
                Swal.fire('Pago eliminado', 'El pago ha sido eliminado y las cuotas recalculadas.', 'success');
                props.setActualizar((act) => act + 1);
                document.querySelector('#exampleModal .btn-close').click();
            } else {
                Swal.fire('Error', 'Ha habido un error al intentar eliminar el pago.', 'warning');
            }
        }
    };

    return (
        <>
            <div className="accordion mt-3" id="accordionFlushPagos">
                <div className="accordion-item">
                    <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsePagos" aria-expanded="false" aria-controls="flush-collapsePagos">
                        Ver pagos
                    </button>
                    </h2>
                    <div id="flush-collapsePagos" className="accordion-collapse collapse" data-bs-parent="#accordionFlushPagos">
                    <div className="accordion-body">
                    <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">Fecha</th>
                            <th scope="col">Descripción</th>
                            <th scope="col">Monto</th>
                            <th scope="col">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.venta.pagos?props.venta.pagos.map((item,i)=>
                            {
                                return <tr key={'tr-'+i}>
                                <th scope="row"  key={'d-'+i}>{item.idPago?item.idPago:item.idRefPago?item.idRefPago:''}</th>
                                <td  key={'f-'+i}>{new Date(item.fecha+'T00:00:00').toLocaleDateString()}</td>
                                <td  key={'dp-'+i}>{item.descripcion?item.descripcion:''}</td>
                                <td  key={'m-'+i}>$ {item.monto.toLocaleString()}</td>
                                <td  key={'a-'+i}><FontAwesomeIcon icon={faTrash} className="pointer" onClick={()=>cancelarPago(item)}/></td>
                                </tr>
                            }

                            ):''}
                        </tbody>
                        </table>
                        </div>
                        <button type="button" className="btn btn-outline-primary" onClick={()=>setCargarNuevoPago(true)}>Registrar nuevo pago</button>
                        {cargarNuevoPago?
                        <div className="border rounded mt-3 p-2">
                            {props.venta.idRefinanciamiento?
                            <DetalleRefPago action="Registrar" settedCliente={props.venta.idCliente} settedRefinanciamiento={props.venta.idRefinanciamiento} setActualizar={props.setActualizar}/>:
                            <DetallePago action="Registrar" settedCliente={props.venta.idCliente} settedVenta={props.venta.idVenta} setActualizar={props.setActualizar}/>}
                        </div>:''}
                    </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default DetallePagosPorVenta;